<template>
  <div class="container">
    <div class="background">
      <div class="line"></div>
      <div class="right-top"></div>
      <div class="line-gray"></div>
    </div>
    <div class="screens">
      <div v-if="screen === SCREENS.intro" class="intro-screen">
        <div>
          <h3>
            ХАЙКНИ СВОЙ ОТПУСК
          </h3>
          <p>
            вместе с Japan Airlines и «Рамблером»! <br />
            Такую Японию вы еще не знали.<br />
            И это лучший повод туда отправиться.
          </p>
        </div>

        <div class="image-container">
          <button @click="() => showHokku()">
            найти повод
          </button>
          <img src="../assets/intro.jpg" alt="" />
        </div>
        <a target="_blank" href="/doc.pdf">Политика конфиденциальности</a>
      </div>
      <div class="hokkus" v-if="screen === SCREENS.hokku">
        <div
          v-for="(item, index) in HOKKU"
          v-bind:key="index"
          v-if="index === hokkuId"
          class="hokku"
        >
          <h3 v-html="item.text" data-aos="fade-right"></h3>
          <div class="image-container">
            <img
              :src="item.image"
              data-aos="fade-left"
              data-aos-delay="300"
              width="511"
              height="281"
              alt=""
            />
          </div>
          <div class="bottom-container">
            <ShareBlock :title="currentHokku.message" />
            <button
              @click="() => shuffle()"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              найти еще повод
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import random from "seedrandom";
const SCREENS = {
  intro: "intro",
  hokku: "hokku"
};

import { HOKKU } from "../data/hokku";
import ShareBlock from "./ShareBlock";

export default {
  name: "Main",
  created() {
    this.shuffle(false);
  },
  components: {
    ShareBlock
  },
  data() {
    return {
      screen: SCREENS.intro,
      hokkuId: 0,
      SCREENS,
      HOKKU
    };
  },
  computed: {
    currentHokku() {
      return HOKKU[this.hokkuId];
    }
  },
  methods: {
    showHokku() {
      this.screen = SCREENS.hokku;
    },
    shuffle(event = true) {
      event &&
        this.$ga.event(
          "Хокку",
          "Показываем случайное хокку",
          "Показываем случайное хокку"
        );
      const rand = new random();
      const newId = Math.floor(rand() * (HOKKU.length - 1));
      if (newId === this.hokkuId) {
        this.shuffle(false);
      } else {
        this.hokkuId = newId;
      }
    }
  }
};
</script>

<style scoped lang="scss">
$red: #e30613;
$gray: #f5f5f5;

h3 {
  margin: 0;
  color: #000000;
  font-size: 34px;
  font-weight: 500;
  line-height: 26px;
  text-align: left;
  text-transform: uppercase;
}

p {
  margin: 0;
  color: #000000;
  font-size: 26px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
}

a {
  color: #000000;
  font-size: 12px; /* Приближение из-за подстановки шрифтов */
  font-weight: 400;
  line-height: 24px; /* Приближение из-за подстановки шрифтов */
  text-decoration: underline;
  text-align: left;
  opacity: 0.6;

  &:hover {
    opacity: 0.8;
  }
}

.container {
  position: relative;
  width: 100%;
  height: 540px;
  overflow: hidden;

  .background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    .line {
      position: absolute;
      left: 40px;
      top: 0;
      width: 2px;
      height: 300px;
      background: $red;
    }
    .right-top {
      position: absolute;
      right: 0;
      top: 0;
      width: 186px;
      height: 182px;
      background: url("../assets/rt.png");
    }
    .line-gray {
      position: absolute;
      right: 40px;
      bottom: 0;
      width: 2px;
      height: 320px;
      background: $gray;
    }
  }
}
.screens {
  margin: 40px 80px 0;

  .intro-screen {
    p {
      margin-top: 20px;
    }
    .image-container {
      position: relative;
      display: flex;
      justify-content: flex-end;

      margin-top: 35px;

      button {
        position: absolute;
        left: 0;
        top: 9px;

        z-index: 2;

        width: 130px;
        height: 40px;

        color: #ffffff;
        font-size: 12px; /* Приближение из-за подстановки шрифтов */
        font-weight: 400;
        line-height: 30px; /* Приближение из-за подстановки шрифтов */
        text-align: center;
        text-transform: uppercase;

        background: $red;
        border: 1px solid $red;

        &:hover {
          color: $red;
          background: white;
        }
      }
    }
    a {
      display: block;
      margin-top: 22px;
      margin-left: -40px;
    }
  }

  .hokku {
    h3 {
      font-size: 35px; /* Приближение из-за подстановки шрифтов */
      font-weight: 500;
      line-height: 42px; /* Приближение из-за подстановки шрифтов */
      text-align: left;
    }
    .image-container {
      position: relative;
      display: flex;
      justify-content: flex-end;

      margin-top: 14px;
    }
    .bottom-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin-top: 20px;
    }
    button {
      width: 160px;
      height: 40px;
      margin-right: 40px;

      font-size: 12px; /* Приближение из-за подстановки шрифтов */
      font-weight: 400;
      line-height: 30px; /* Приближение из-за подстановки шрифтов */
      text-align: center;
      text-transform: uppercase;
      color: $red;
      background: white;

      border: 1px solid $red;

      &:hover {
        background: $red;
        color: #ffffff;
      }
    }
  }
}

@media screen and (max-width: 669px) {
  .container {
    height: 490px;

    .background {
      .line {
        left: 5px;
        width: 2px;
        height: 200px;
      }
      .right-top {
        background-size: contain;
        width: 74px;
        height: 72px;
        background-repeat: no-repeat;
      }

      .line-gray {
        right: 5px;
        width: 2px;
        height: 200px;
      }
    }

    .screens {
      margin: 25px 20px 0 25px;
      height: 100%;

      h3 {
        font-size: 22px; /* Приближение из-за подстановки шрифтов */
        font-weight: 500;
        line-height: 26px; /* Приближение из-за подстановки шрифтов */
        text-align: left;
      }
      .intro-screen {
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        p {
          font-size: 18px;
          line-height: 26px;
          text-align: left;
          margin-top: 0;
        }

        .image-container {
          flex-direction: column;
          margin-top: 0;

          button {
            position: relative;
            left: auto;
            top: auto;
            width: 100px;
            height: 25px;
            font-size: 9px; /* Приближение из-за подстановки шрифтов */
            font-weight: 400;
            line-height: 15px;
          }

          img {
            margin-top: 19px;
            height: auto;
            width: 100%;
            max-width: 510px;
            max-height: 280px;
            align-self: center;
          }
        }

        a {
          margin-top: 5px;
          margin-left: -10px;
          font-size: 12px;
          line-height: 12px;
        }
      }
      .hokkus {
        height: 100%;
      }

      .hokku {
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        h3 {
          font-size: 22px; /* Приближение из-за подстановки шрифтов */
          font-weight: 500;
          line-height: 27px; /* Приближение из-за подстановки шрифтов */
          text-align: left;
        }
        .image-container {
          display: flex;
          justify-content: center;

          img {
            width: 100%;
            height: auto;
            max-width: 510px;
            max-height: 280px;
          }
        }

        .bottom-container {
          margin-top: 1px;
          margin-bottom: 0px;
        }

        button {
          width: 115px;
          height: 28px;
          font-size: 9px; /* Приближение из-за подстановки шрифтов */
          font-weight: 400;
          line-height: 15px;
          margin: 0;
        }
      }
    }
  }
}
</style>
